
<div class="flex flex-col sm:h-full sm:flex-row items-center">
    <div class="sm:w-3/5 sm:h-full w-full
        h-1/2 grid place-content-center
        bg-emerald-50 ">
        <landing-screen class="p-6 sm:p-32"></landing-screen>
    </div>
    <!-- <div class="ie-fix w-full h-full px-10 flex content-center flex-col bg-red-200 text-red-900"
        *ngIf="isExpiredLink">
        <h2>EXPIRED</h2>
        <p>Your password reset link has been expired.
            Please enter your email address next to receive a new
            password reset link</p>
        <mat-divider></mat-divider>
        <div>
            <button mat-flat-button color="warn"
                [routerLink]="['/forgot-password']">OK</button>
        </div>
    </div> -->
    <div class="ie-fix sm:w-2/5
        sm:h-full w-full h-1/2 px-10 grid place-items-center"
        *ngIf="isVerifiedUser">
        <form [formGroup]="setPasswordFormGroup">
            <p class="text-3xl sm:text-4xl leading-loose font-bold
                text-green-700">Set Password</p>
            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="New Password"
                    formControlName="password">
                <mat-hint align="end">Password must contain at least 8
                    characters.</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="Confirm Password"
                    formControlName="confirmPassword">
            </mat-form-field>
            <div>
                <button mat-raised-button (click)="setPassword()"
                    [disabled]="setPasswordFormGroup.invalid"
                    class="login-button" color="primary">Save</button>
            </div>
        </form>
    </div>

    <mat-card class="ie-fix sm:w-2/5
        sm:h-full w-full h-1/2 px-10 grid place-items-center"
        *ngIf="!isVerifiedUser">
        <mat-card-title>Unauthorized User</mat-card-title>
        <p class="text-[24-px] sm:text-[36-px] leading-relaxed font-bold
            text-red-500">
            You are not authorized to perform any action on this page.
        </p>
    </mat-card>
</div>
